import { render, staticRenderFns } from "./AssignmentHeader.vue?vue&type=template&id=611972d0&scoped=true&"
import script from "./AssignmentHeader.vue?vue&type=script&lang=js&"
export * from "./AssignmentHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611972d0",
  null
  
)

export default component.exports